(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuture-advertorial"] && !Shopify.designMode) return;
  try {
    
  // Compartilhamento
  document.querySelectorAll('[data-adv-share]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const type = btn.getAttribute('data-adv-share');
      const shareUrl = window.location.href;
      const u = encodeURIComponent(shareUrl);
      const t = encodeURIComponent(document.title);
      if (type === 'facebook') {
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${u}`, '_blank', 'noopener');
      } else if (type === 'whatsapp') {
        window.open(`https://api.whatsapp.com/send?text=${t}%20${u}`, '_blank', 'noopener');
      } else if (type === 'native' && navigator.share) {
        navigator.share({ title: document.title, url: shareUrl }).catch(() => {});
      } else {
        navigator.clipboard?.writeText(shareUrl);
      }
    });
  });

  // Sticky mobile: aparece depois do marcador [data-adv-sticky-after]
  // (ou 150vh se não houver marcador) e some enquanto a oferta está visível.
  (() => {
    const sticky = document.querySelector('[data-adv-sticky]');
    if (!sticky) return;
    const offer = document.querySelector('[data-adv-offer]');
    const marker = document.querySelector('[data-adv-sticky-after]');
    let reached = !marker;
    let offerVisible = false;
    const render = () => sticky.classList.toggle('is-visible', reached && !offerVisible);
    if (marker && 'IntersectionObserver' in window) {
      const obs = new IntersectionObserver(
        ([e]) => {
          if (e.isIntersecting || e.boundingClientRect.top < 0) {
            reached = true;
            render();
            obs.disconnect();
          }
        },
        { threshold: 0, rootMargin: '0px 0px -20% 0px' },
      );
      obs.observe(marker);
    } else {
      render();
    }
    if (offer && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        ([e]) => {
          offerVisible = e.isIntersecting;
          render();
        },
        { threshold: 0.2 },
      ).observe(offer);
    }
  })();

  // Tracking dos CTAs [data-adv-cta] agora é unificado no assets/nuture-track.js
  // (select_promotion no GA4 + view_promotion + Triple Whale + UTM handoff),
  // carregado globalmente pelo theme.liquid. Nada a fazer aqui — os atributos
  // data-adv-cta continuam sendo lidos por lá.

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuture-listicle-article"] && !Shopify.designMode) return;
  try {
    
  // Cabeçalho sobreposto: a barra nasce transparente por cima da foto de
  // abertura e vira branca assim que a rolagem começa. Quem pinta é o CSS em
  // assets/nuture-listicle.css; aqui só se decide o estado.
  //
  // O gatilho é baixo de propósito (24px): o pedido é "depois de começar a
  // scrolar", não "depois de passar do hero".
  (() => {
    if (!document.querySelector('[data-lst-overlay-header]')) return;

    const SOLID_AT = 24;
    let solid = null;

    const sync = () => {
      const next = window.scrollY > SOLID_AT;
      if (next === solid) return;
      solid = next;
      document.body.classList.toggle('nuture-listicle--header-solid', next);
    };

    sync();
    window.addEventListener('scroll', sync, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
